export class SocialHistory {
  end_date?: string;
  dt?: string;
  firstname?: string;
  coding_id?: string;
  patient_id?: number;
  description?: string;
  version_id?: number;
  start_date?: string;
  status?: number;
  lastname?: string;
  [key: string]: any;
}
